import React from 'react';

const Headline = ({
  children,
  className,
  padding = 0,
  xSmall = false,
  small = false,
  normal = false,
  large = false,
  alignRight = false,
  alignLeft = false
}) => {

  // const classList = ['headline', ...className.split(' ')];
  const classList = ['headline'];
  let padStyle;

  if (xSmall) classList.push('XSmall');
  else if (small) classList.push('Small');
  else if (normal) classList.push('Normal');
  else if (large) classList.push('Large');

  if (alignRight) {
    classList.push('Align-right');
    padStyle = { paddingRight: padding };
  } else if (alignLeft) {
    classList.push('Align-left');
    padStyle = { paddingLeft: padding };
  }


  const childrenNew = React.Children.map(children, (child, key) => {

    const addPadding = Object.assign(
      {},
      child.props.style,
      padStyle
    );

    return React.cloneElement(child, { style: addPadding })
  });

  return (
    <div
      className={classList.join(' ')}
    >
      {childrenNew}
    </div>
  );
};

export default Headline;


// WEBPACK FOOTER //
// ./src/components/theme/Headline/Headline.jsx